import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/platforms";

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[72px] flex items-center justify-between gap-4">
          <a href="#home" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg text-foreground-950 tracking-tight">瓜圈榜</span>
              <span className="text-[10px] text-foreground-500 tracking-[0.18em] mt-0.5">GUAQUAN RANK</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3 shrink-0">
            <a
              href="#contact"
              className="px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              提交推荐
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 mb-1 py-2.5 text-center text-sm rounded-md bg-primary-500 text-background-50 cursor-pointer"
            >
              提交推荐
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}